import React from 'react';
import { Tab, Nav, Row, Col } from 'react-bootstrap';
import { useLocation, useHistory } from 'react-router-dom';
import { useSetTab } from '../../../services/hooks';
import TalentDataTable from './TalentDataTable';
import TalentDncDataTable from './TalentDncDataTable';
import TalentSurveyDataTable from './TalentSurveyDataTable';

const EmployeeTalentTabs = ({ employee }) => {
  const location = useLocation();
  const history = useHistory();
  const [key, setKey] = useSetTab('capacitaciones', location, 'talentTab');

  const handleTabSelect = k => {
    setKey(k);
    if (k) {
      const searchParams = new URLSearchParams(location.search);
      searchParams.set('talentTab', k);
      history.replace({ search: searchParams.toString() });
    }
  };

  return (
    <Tab.Container id="employee-talent-tabs" activeKey={key} onSelect={handleTabSelect} mountOnEnter>
      <Row className="align-items-center mt-3 mb-3 mx-1">
        <Col>
          <Nav variant="pills" className="ab-pills">
            <Nav.Item>
              <Nav.Link eventKey="dnc">DNC</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="capacitaciones">Capacitaciones</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="encuestas">Encuestas</Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>
      </Row>

      <Tab.Content>
        <Tab.Pane eventKey="dnc">
          <TalentDncDataTable employeeId={employee.id} />
        </Tab.Pane>
        <Tab.Pane eventKey="capacitaciones">
          <TalentDataTable employeeId={employee.id} />
        </Tab.Pane>
        <Tab.Pane eventKey="encuestas">
          <TalentSurveyDataTable employeeId={employee.id} />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  );
};

export default EmployeeTalentTabs;
